import React, {lazy, Suspense} from 'react';
import {Routes, Outlet} from 'react-router-dom';
import './apm/components/common/styles/app.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './apm/components/common/styles/rsuite.css'
import 'apm/translation/index';
import RequireAuth from './apm/contexts/RequireAuth';
import {PageLoading} from 'apm/components/common';
import {Toaster} from "react-hot-toast";
import APMRoutes from "./apm/routes";
const Maintenance = lazy(() => import('./Maintenance'));

function App() {
    const maintenance = false;
    return (
        <>
            {maintenance ? <Maintenance/> :
                <div className={`mdk-header-layout js-mdk-header-layout`}>
                    <GlobalToaster/>
                    <RequireAuth>
                        <Suspense fallback={<PageLoading/>}>
                            <Routes>
                                {APMRoutes()}
                            </Routes>
                        </Suspense>
                        <Outlet/>
                    </RequireAuth>
                </div>
            }
        </>
    );
}

const GlobalToaster = () => {
    return (
        <Toaster
            containerStyle={{
                top: 110,
            }}
            position="top-center"
            reverseOrder={false}
        />
    )
}

export default App;
